/* ============================================================================
   ZIROR - CART SIGNAL PRIMITIVE  (25/7/2026)
   1 nguon duy nhat cho: "gio vua doi" + "dem may cai mu" + "doc /cart.js".
   Cung ho voi zr-sticky-preview.js: primitive dung chung, consumer opt-in.

   ---------------------------------------------------------------------------
   VI SAO TON TAI (do duoc, khong suy dien)
   ---------------------------------------------------------------------------
   Truoc file nay co BA ban sao cua cung mot logic, moi ban doan gio thay doi
   bang mot dong ho rieng:
     - zr-bundle-progress (/cart)   : setTimeout(sync, 900)
     - zr-emb-bundle (PDP theu)     : [900, 2200, 4000].forEach(setTimeout(refresh))
     - va ca hai tu dinh nghia hatCount() rieng
   Hai hau qua da do duoc:
     1) TRE + KET IM LANG tren /cart. Boost debounce ghi gio 500ms TRAILING
        (theme.js:6776 + theme.debounce theme.js:97) roi moi POST /cart/change.js.
        Doc luc t=900 chi con 400ms ngan sach RTT; mobile 4G/5G vuot la thuong.
        Doc truoc commit -> so khong doi -> ban cu bail bang `key===lastKey` va
        KHONG hen lai -> bar dung o so cu cho toi khi khach cham viec khac.
     2) 3 request /cart.js moi lan add tren PDP theu. Bo nho du an: /cart.js la
        dung thu tra 429 khi ban nha day. Ban 3 phat de "cho chac" chinh la cai
        lam no 429.

   ---------------------------------------------------------------------------
   CACH LAM: nghe TIN HIEU THAT, khong doan thoi diem
   ---------------------------------------------------------------------------
   (1) jQuery `ajaxComplete` - duong chinh. Boost di qua jQuery cho MOI thao tac
       gio: add (theme.js:4071), change (6926), sections (6882), cart.js (4207).
       jQuery ban global ajaxComplete SAU success callback cuc bo.
   (2) hook `window.fetch` - bao hiem cho theme/app khong dung jQuery.
   (3) luoi an toan CO BOUND: cham vao vung gio ma 2.5s khong thay tin hieu nao
       -> tu doc lai. Bounded + co dieu kien thoat + co log khi bo cuoc.

   `/cart/change.js` TRA VE NGUYEN CART trong body => phat thang, khong ton them
   request. Moi lan doi so luong truoc day ton 3 request; gio con 2.

   !! `/cart.js` KHONG duoc coi la "cart write" - chinh primitive nay goi no.
      Coi no la write = vong lap vo han.
   !! KHONG dung MutationObserver toan trang (bay 19/7: paint ghi DOM -> observer
      ban -> lap vo han -> "Page Unresponsive" tren PDP that).

   ---------------------------------------------------------------------------
   API
   ---------------------------------------------------------------------------
     ZRCart.onChange(fn)  -> dang ky; goi ngay voi cart hien co neu da co
     ZRCart.get()         -> cart moi nhat da biet (hoac null)
     ZRCart.refresh(why)  -> ep doc lai (da gop nhip + chong trung request)
     ZRCart.hatCount(c)   -> 1 DINH NGHIA DUY NHAT cua scope bac gia
     ZRCart.stats         -> {fetches, emits, signals} - QA assert vao day

   Consumer nap truoc primitive (script inline chay truoc <script defer>) thi
   day vao hang doi:
     (window.ZRCartQ = window.ZRCartQ || []).push(function(ZRCart){ ... });

   NGUON SCOPE: automatic discount o Admin ap cho collection custom-hats +
   embroidered-hats. Verify live 25/7 qua GraphQL: 15/15 SP active co
   product_type 'Hat' deu nam trong 2 collection do => 'Hat' la proxy DUNG.
   Them dong mu moi ma quen bo vao collection => bar noi doi. Xem gate
   check_hat_scope.py.
   ============================================================================ */
(function () {
  'use strict';
  if (window.ZRCart) return;

  var VER = '2026-07-25';
  /* !! Giu ban GOC cua fetch va dung no cho lan doc CUA CHINH MINH.
     Do duoc 25/7: neu read() di qua ban da hook thi hook quan sat lai chinh no -
     clone().json() cua hook resolve SAU khi `inflight` da ve null, nen onCartRead()
     tuong day la ban doc cua nguoi khac => phat trung (freeEmits=2 trong khi chi co
     1 tin hieu doc). Khong ton them request, nhung `clearTimeout(coalesce)` trong
     nhanh do co the HUY NHAM mot lan doc dang hen. Tu quan sat minh la mam loi. */
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var subs = [];
  var last = null;
  var inflight = null;
  var coalesce = null;
  var fallback = null;
  var tries = 0;
  /* freeEmits = so lan ve lai MA KHONG ton request (doc tu body /cart/change.js).
     QA assert vao day de biet duong "0 round trip" that su co chay. */
  var stats = { fetches: 0, emits: 0, signals: 0, fallbacks: 0, freeEmits: 0 };

  function hatCount(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it && it.product_type === 'Hat') n += (it.quantity || 0);
    }
    return n;
  }

  /* !! BAY THAT SU, KHONG PHAI LO XA (tim ra luc tu soi lai 25/7):
     POST /cart/add.js voi payload {items:[...]} tra ve {"items":[...]} - CO key
     `items` nhung KHONG PHAI cart: khong co total_price, khong co discount_codes.
     Guard so khai `if (body && body.items)` se nuot no lam cart =>
       total_price undefined -> 0 -> toFree = 10000 -> bar in "$100.00 to free
       shipping" trong khi gio dang co 3 mu. Noi doi ve TIEN, dung hang loi
       dang di sua.
     => Chi coi la cart khi CO DU hinh dang cua mot cart that. Kiem tra hinh dang,
        khong tin ten key. */
  function isCartShape(c) {
    return !!c && Array.isArray(c.items)
      && typeof c.total_price === 'number'
      && typeof c.item_count === 'number';
  }

  function emit(cart) {
    if (!isCartShape(cart)) return;
    last = cart;
    stats.emits++;
    for (var i = 0; i < subs.length; i++) {
      /* mot consumer nem loi KHONG duoc lam chet cac consumer con lai */
      try { subs[i](cart); } catch (e) { console.warn('[zr-cart-signal] subscriber loi', e); }
    }
  }

  function read(why) {
    /* chong trung request: nhieu consumer goi cung luc -> 1 request */
    if (inflight) return inflight;
    if (!nativeFetch) return null;
    stats.fetches++;
    inflight = nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        inflight = null;
        tries = 0;
        emit(cart);
        return cart;
      })
      .catch(function (e) {
        inflight = null;
        /* !! 19/7: mot lan /cart.js hong (429 / mang chap) ma khong retry la bar
           dung trong vinh vien. Retry co BOUND + backoff, khong im lang. */
        console.warn('[zr-cart-signal] doc /cart.js hong (' + why + ')', e);
        if (++tries <= 2) setTimeout(function () { read('retry' + tries); }, 1500 * tries);
        return null;
      });
    return inflight;
  }

  function refresh(why, delay) {
    clearTimeout(coalesce);
    coalesce = setTimeout(function () { read(why || 'refresh'); }, delay || 0);
  }

  /* ------------------------------------------------------------ TIN HIEU */

  function cartUrlKind(u) {
    u = String(u || '');
    /* !! /cart.js KHONG nam trong day - read() dung chinh no => se thanh vong lap.
       No duoc xu ly rieng qua onCartRead(): CHI adopt body, TUYET DOI khong refresh. */
    if (u.indexOf('/cart/change') > -1) return 'change';
    if (u.indexOf('/cart/add') > -1) return 'add';
    if (u.indexOf('/cart/update') > -1) return 'update';
    if (u.indexOf('/cart/clear') > -1) return 'clear';
    return '';
  }

  function isCartReadUrl(u) {
    u = String(u || '');
    /* chi khop dung endpoint doc gio, khong khop /cart/... */
    return /\/cart\.js(\?|$)/.test(u.split('#')[0]);
  }

  /* !! DO DUOC 25/7 tren PDP theu: bam ADD -> 2 request /cart.js cach nhau 1ms.
     Mot cua POPUP ATC cua theme ($.getJSON('/cart.js'), theme.js:4207) - no da co
     NGUYEN cai cart trong tay. Mot cua primitive di doc LAI cung thu do.
     => Nghe ke ca ban doc cua NGUOI KHAC: ai fetch /cart.js thi minh an theo body.
     An toan vi day la READ: chi adopt, khong bao gio kich refresh => khong the lap.
     Ket qua: ATC tu 2 request con 1 (san cua theme), tuc cham san. */
  function onCartRead(body) {
    if (!isCartShape(body)) return;
    if (inflight) return;        /* ban cua chinh minh - .then() se emit roi */
    clearTimeout(coalesce);      /* co so moi hon roi -> huy lan doc dang hen */
    stats.freeEmits++;
    emit(body);
  }

  function onCartWrite(kind, body) {
    stats.signals++;
    clearTimeout(fallback);
    /* change/update/clear tra ve NGUYEN CART -> phat thang, 0 request them.
       add.js thi KHONG (xem isCartShape) -> phai doc lai.
       Nhung hoan 300ms: neu popup ATC cua theme tu fetch /cart.js trong khoang do
       thi onCartRead() da phat roi va lan doc nay bi huy. */
    if (kind !== 'add' && isCartShape(body)) { stats.freeEmits++; emit(body); return; }
    refresh('write:' + kind, kind === 'add' ? 300 : 0);
  }

  /* (1) jQuery ajaxComplete - cho toi 2s roi bo cuoc CO BAO */
  var jqTries = 0;
  (function bindJq() {
    var jq = window.jQuery;
    if (jq && jq.fn) {
      jq(document).on('ajaxComplete.zrcart', function (e, xhr, settings) {
        var u = settings && settings.url;
        var kind = cartUrlKind(u);
        if (kind) { onCartWrite(kind, xhr && xhr.responseJSON); return; }
        if (isCartReadUrl(u)) onCartRead(xhr && xhr.responseJSON);
      });
      return;
    }
    if (++jqTries > 40) {
      console.warn('[zr-cart-signal] khong thay jQuery sau 2s - chay bang fetch-hook + luoi 2.5s');
      return;
    }
    setTimeout(bindJq, 50);
  })();

  /* (2) fetch hook - luon tra ve promise GOC, khong nuot rejection */
  if (window.fetch) {
    var _fetch = window.fetch;   /* read() KHONG dung ban nay - xem nativeFetch */
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      var kind = cartUrlKind(url);
      var isRead = !kind && isCartReadUrl(url);
      if (kind || isRead) {
        p.then(function (res) {
          if (res && res.ok && res.clone) {
            res.clone().json().then(
              function (b) { if (kind) { onCartWrite(kind, b); } else { onCartRead(b); } },
              function () { if (kind) onCartWrite(kind, null); }
            );
          } else if (kind) {
            onCartWrite(kind, null);
          }
        }, function () { /* request hong: luoi an toan lo */ });
      }
      return p;
    };
  }

  /* (3) luoi an toan co BOUND: cham vung gio ma khong thay tin hieu -> tu doc lai */
  ['click', 'change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.quantity__change, [name="updates[]"], .quantity__remove, form[action*="/cart"], button[name="add"], [type="submit"][name="add"]')) return;
      clearTimeout(fallback);
      fallback = setTimeout(function () {
        stats.fallbacks++;
        console.warn('[zr-cart-signal] 2.5s khong co tin hieu ajax - dung luoi an toan');
        read('fallback');
      }, 2500);
    }, true);
  });

  /* Back/forward (bfcache): DOM cu nhung gio co the da doi o tab khac.
     !! PHAI kiem `e.persisted`: `pageshow` ban CA O LAN TAI DAU, khong chi khi
     khoi phuc tu bfcache. Ban dau bo qua cho nay -> do duoc stats.fetches = 2
     ngay khi vua vao /cart (init + pageshow) => doc /cart.js gap doi can thiet
     tren MOI page load, dung cai endpoint hay tra 429 nhat. */
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) refresh('bfcache', 0);
  });

  window.ZRCart = {
    version: VER,
    stats: stats,
    hatCount: hatCount,
    get: function () { return last; },
    refresh: refresh,
    onChange: function (fn) {
      if (typeof fn !== 'function') return;
      subs.push(fn);
      if (last) { try { fn(last); } catch (e) { console.warn('[zr-cart-signal]', e); } }
    }
  };

  /* drain hang doi cua consumer da chay TRUOC file defer nay */
  var q = window.ZRCartQ;
  window.ZRCartQ = { push: function (fn) { try { fn(window.ZRCart); } catch (e) { console.warn('[zr-cart-signal]', e); } } };
  if (q && q.length) {
    for (var i = 0; i < q.length; i++) {
      try { q[i](window.ZRCart); } catch (e) { console.warn('[zr-cart-signal]', e); }
    }
  }

  read('init');
})();
